import { getAxiosClient } from "../shared";

export const thornode = getAxiosClient({
  baseURL: "https://thornode.thorswap.net/thorchain/",
});
